import { render, staticRenderFns } from "./LkTableHeaderCell.vue?vue&type=template&id=7996b889&"
import script from "./LkTableHeaderCell.vue?vue&type=script&lang=js&"
export * from "./LkTableHeaderCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports